import CryptoJS from "crypto-js"

const crypt = (value) => {
    return CryptoJS.AES.encrypt(value, process.env.VUE_APP_SECRET_KEY).toString();
}

const decryptObj = (cipher) => {
    const bytes  = CryptoJS.AES.decrypt(cipher, process.env.VUE_APP_SECRET_KEY);
    const string = bytes.toString(CryptoJS.enc.Utf8);
    if(string) {
        return JSON.parse(string)
    } else {
        return ""
    }
}

export default {
    crypt,
    decryptObj
}